import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUpdateClinic } from '../types';
import withUploadedLogo from './withUploadedLogo';

const onUpdateClinic: IThunkUpdateClinic = thunk(async (_, { clinicId, data }) => {
  const payload = await withUploadedLogo(data);
  await api.clinic.updateClinic(clinicId, payload);
});

export default onUpdateClinic;
